export const availableSubsystems = [
    "BRK",
    "CHAS",
    "COOL",
    "DASH",
    "DRV",
    "DRIVER GEAR",
    "ELE",
    "ENGN",
    "ERGO",
    "EXH",
    "FUEL",
    "INT",
    "PDL",
    "STR",
    "SUS",
    "SHFT",
];

export const priorityLevels = ["LOW", "MEDIUM", "HIGH", "CRITICAL"];
export const statusOptions = ["OPEN", "IN PROGRESS", "CLOSED"];